module.exports = __webpack_public_path__ + "3aba53aaf95007fb9f9240bc6e863a1c.png";